import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'carm-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() btnLabel: string;
  @Input() title: string;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() customClass: string;
  @Input() inId: string;
  @Input() inDataCy: string;

  @Input() iconCheckMark: boolean;
  @Input() iconAdd: boolean;
  @Input() iconMinus: boolean;
  @Input() iconRemove: boolean;
  @Input() iconPrevious: boolean;
  @Input() iconNext: boolean;
  @Input() iconPencil: boolean;
  @Input() iconSave: boolean;
  @Input() iconForward: boolean;
  @Input() iconBackward: boolean;
  @Input() iconPlus: boolean;
  @Input() iconExpandAll: boolean;
  @Input() iconCollapseAll: boolean;

  @Input() btnTypePrimary: boolean;
  @Input() btnTypeDefault: boolean;
  @Input() btnTypeDanger: boolean;
  @Input() btnStretch: boolean;

  @Input() spaceTop: boolean;
  @Input() spaceBottom: boolean;
  @Input() spaceTopLarge: boolean;
  @Input() spaceNone: boolean;

  constructor() { }

  ngOnInit() {
  }
}
